module.exports = __webpack_public_path__ + "media/images/front/bg_m-51f33248ef20b439fd6e0e529747e5d4.jpg";